import _ from 'lodash';
import { forwardRef, useEffect, useRef, useState } from 'react';
import { Button, Form, Modal } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { COMMUNITY_IMAGE_URL, US_STATES, getStateByCode } from '../../constants/common';
import { getAgents } from '../../services/admin';
import { getMarkets } from '../../services/general';
import { getUserType } from '../../utils/common';
import Loader from '../loader';

const AgentPage = styled.div`
  display: flex;
  padding: 160px 60px 60px;
  flex-direction: column;
  align-items: center;
  gap: 100px;
  flex: 1 0 0;
  position: relative;
  max-width: 1500px;
  width: 100%;
  margin: 0 auto;

  @media (min-width: 1600px) {
    padding: 120px;
  }
`;
const AgentDetail = styled.div`
  display: flex;
  justify-content: center;
  align-items: self-start;
  gap: 64px;
  align-self: stretch;
`;
const UploadPhotoWrapper = styled.div`
  position: relative;
  display: flex;
  flex: 0 0 450px;
  height: 450px;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  border-radius: ${(props) => (props.rounded ? '50%' : 'unset')};
  border: ${(props) => (props.rounded ? '1px solid var(--ywh-silver-chalice, #A8A8A8)' : 'none')};

  & img {
    height: 450px;
    width: 450px;
    border-radius: 50%;
    object-fit: cover;
    cursor: pointer;
  }

  &.upload-photo-wrapper {
    flex-basis: 100%;
  }
`;
const UploadPhotoIcon = styled.div`
  height: 450px;
  width: 450px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  & h5 {
    color: var(--ywh-silver-chalice, #a8a8a8);
    text-align: center;
    /* ywh-h5-regular */
    font-family: Montserrat;
    font-size: 24px;
    font-style: normal;
    font-weight: 400;
    line-height: 36px; /* 150% */
  }
`;
const AgentInfoWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: flex-start;
  gap: 48px;
  align-self: stretch;
`;
const Input = styled.input`
  display: flex;
  padding: 16px 24px;
  align-items: center;
  align-self: stretch;
  border-radius: 8px;
  border: 1px solid var(--ywh-manatee, #8d99ae);
  width: 100%;

  &::placeholder {
    color: var(--ywh-silver-chalice, #a8a8a8);

    /* ywh-h6-regular */
    font-family: Montserrat;
    font-size: 21px;
    font-style: normal;
    font-weight: 400;
    line-height: 31.5px; /* 150% */
  }
  &:focus {
    outline: none;
  }
  &.has-error {
    border: 1px solid red;
  }
`;
const InputGroup = styled.div`
  display: flex;
  min-height: 50px;
  padding: 16px;
  justify-content: center;
  align-items: center;
  gap: 16px;
  align-self: stretch;
  border-radius: 8px;
  border: 1px solid var(--ywh-silver-chalice, #a8a8a8);
  background: #fff;

  & input {
    padding: 0px 0px 0px 16px;
    border-radius: unset;
    border: none;
    border-left: 1px solid var(--ywh-silver-chalice, #a8a8a8);

    /* ywh-caption */
    font-family: Montserrat;
    font-size: 17px;
    font-style: normal;
    font-weight: 400;
    line-height: 27.54px; /* 162% */
  }

  &.has-error {
    border: 1px solid red;
  }
`;
const AgentEmailPasswordWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
`;
const AgentNameWrapper = styled.div`
  display: flex;
  min-width: 550px;
  padding-bottom: 0px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
  border-bottom: 2px solid var(--ywh-alto, #d8d8d8);
  position: relative;
  & input:last-child {
    margin-bottom: 16px;
  }

  & .close-icon-wrapper {
    position: absolute;
    top: -40px;
    right: 0px;
  }
`;
const AgentDetailsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
  max-width: 1900px;
  width: 100%;
  margin: 0 auto;
`;
const AgentDetailsInputGroup = styled.div`
  display: flex;
  align-items: ${(props) => (props.multi ? 'start' : 'center')};
  gap: 16px;
  align-self: stretch;

  & label {
    min-width: 150px;
    max-width: 150px;
    flex: 1 0 0;
    color: var(--ywh-raisin-black, #2f2f2f);

    /* ywh-h5-bold */
    font-family: Montserrat;
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: 36px; /* 150% */
  }

  & span {
    color: var(--ywh-raisin-black, #2f2f2f);
    text-align: center;
    font-family: Montserrat;
    font-size: 30px;
    font-style: normal;
    font-weight: 700;
    line-height: 39px; /* 130% */
  }

  &.has-error input {
    border: 1px solid red;
  }

  & .loan-officer-container {
    width: 100%;
    & .loan-officer-select__control {
      padding: 10px 24px;
      border-radius: 8px;
      border: 1px solid var(--ywh-manatee, #8d99ae);
    }

    & .loan-officer-select__indicators {
      display: none;
    }

    & .loan-officer-select__value-container  {
      padding-left: 0px;
    }
  }
`;
const MultipleInputContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
`;
const InputWithClose = styled.div`
  display: flex;
  gap: 8px;
  flex: 1;
`;
const AgentDetailsInput = forwardRef(
  ({ label, name, value, onChange, placeholder, multi, className, hasError }, ref) => {
    let MULTI_OBJ = {
      mls: {
        name: '',
        code: '',
        office: '',
      },
      licenses: {
        license: '',
        state: '',
      },
    };

    const [inputs, setInputs] = useState(value || [MULTI_OBJ[name]]);

    const handleRemoveIndex = (index) => {
      let copyInputs = inputs;
      copyInputs.splice(index, 1);
      setInputs([...copyInputs]);
    };

    const onChangeMulti = (k, i, index, e) => {
      inputs[index][k] = e.target.value;
      setInputs(inputs);
    };

    return (
      <AgentDetailsInputGroup ref={ref} multi={multi}>
        <label>{label}</label>
        <span>:</span>

        {!multi && (
          <Input
            className={`${className} ${hasError ? 'has-error' : ''}`}
            ref={ref}
            placeholder={placeholder}
            name={name}
            value={value}
            onChange={onChange}
          />
        )}

        {multi && (
          <MultipleInputContainer onChange={() => onChange({ target: { name, value: inputs } })}>
            {inputs.map((multiObj, index) => {
              let copyIndex = index;
              return (
                <InputWithClose className={`${hasError ? 'has-error' : ''}`}>
                  {Object.keys(multiObj)
                    .filter((k) => ['name', 'code', 'office', 'license', 'state'].includes(k))
                    .map((k, i) => (
                      <Input
                        placeholder={k}
                        name={k}
                        value={multiObj[k]}
                        onChange={(e) => onChangeMulti(k, i, index, e)}
                      />
                    ))}
                  {index == 0 && <AddIcon onClick={() => setInputs([...inputs, MULTI_OBJ[name]])} />}
                  {index > 0 && <CloseIcon onClick={() => handleRemoveIndex(copyIndex)} />}
                </InputWithClose>
              );
            })}
          </MultipleInputContainer>
        )}
      </AgentDetailsInputGroup>
    );
  },
);

const AgentDetailExtra = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  width: 100%;
`;
const AgentContactContainer = styled.div`
  display: flex;
  align-items: center;
  align-content: center;
  gap: 32px;
  align-self: stretch;
  flex-wrap: wrap;
`;
const AgentContactWrapper = styled.div`
  display: flex;

  @media (min-width: 1600px) {
    width: 350px;
    min-width: 350px;
    max-width: 350px;
  }
  flex-direction: column;
  align-items: center;
`;
const AgentContactListItemWrapper = styled.div`
  display: flex;
  padding: 32px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;
  align-self: stretch;

  border-bottom: 1px solid var(--ywh-dim-gray, #686868);
  background: var(--ywh-azure, #5284e0);
  &:first-child {
    border-radius: 16px 0px 0px 0px;
  }
  &:last-child {
    border-radius: 0px 0px 0px 16px;
  }

  & p {
    color: #fff;

    /* ywh-body-text */
    font-family: Montserrat;
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: 32.4px; /* 162% */
    background: transparent;
    text-align: center;
    border: none;
  }
`;
const AgentContactListHeader = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;
  & p {
    color: #fff;
    font-family: Montserrat;
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: 36px; /* 150% */
  }
`;
const AgentContactListField = styled.input`
  display: flex;
  flex-direction: ${(props) => (props.type == 'date' ? 'row' : 'column')};
  justify-content: center;
  align-items: center;
  gap: 8px;
  display: flex;
  min-width: 285px;
  max-width: 285px;
  padding: 12px 24px;
  align-items: center;
  align-self: stretch;
  border-radius: 8px;
  background: var(--ywh-mercury, #e8e8e8);

  color: var(--ywh-silver-chalice, #a8a8a8);

  /* ywh-h6-regular */
  font-family: Montserrat;
  font-size: 21px;
  font-style: normal;
  font-weight: 400;
  line-height: 31.5px; /* 150% */

  &:focus {
    outline: none;
  }

  &.has-error {
    border: 1px solid red;
  }
`;
const SelectCompensation = styled.select`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;
  display: flex;
  min-width: 285px;
  max-width: 285px;
  padding: 12px 24px;
  align-items: center;
  align-self: stretch;
  border-radius: 8px;
  background: var(--ywh-mercury, #e8e8e8);

  color: var(--ywh-silver-chalice, #a8a8a8);

  /* ywh-h6-regular */
  font-family: Montserrat;
  font-size: 21px;
  font-style: normal;
  font-weight: 400;
  line-height: 31.5px; /* 150% */

  &:focus {
    outline: none;
  }
`;
const AgentContactListItem = forwardRef(({ title, icon, name, onChange, value, readOnly, hasError, type }, ref) => {
  return (
    <AgentContactListItemWrapper ref={ref}>
      <AgentContactListHeader>
        {icon && icon === 'brokerage' && (
          <svg xmlns="http://www.w3.org/2000/svg" width="40" height="41" viewBox="0 0 40 41" fill="none">
            <path
              d="M22 28.5V32.5H24C24.5304 32.5 25.0391 32.7107 25.4142 33.0858C25.7893 33.4609 26 33.9696 26 34.5H40V38.5H26C26 39.0304 25.7893 39.5391 25.4142 39.9142C25.0391 40.2893 24.5304 40.5 24 40.5H16C15.4696 40.5 14.9609 40.2893 14.5858 39.9142C14.2107 39.5391 14 39.0304 14 38.5H0V34.5H14C14 33.9696 14.2107 33.4609 14.5858 33.0858C14.9609 32.7107 15.4696 32.5 16 32.5H18V28.5H6V25.5C6 21.64 12.26 18.5 20 18.5C27.74 18.5 34 21.64 34 25.5V28.5H22ZM20 0.5C21.8565 0.5 23.637 1.2375 24.9497 2.55025C26.2625 3.86301 27 5.64348 27 7.5C27 9.35652 26.2625 11.137 24.9497 12.4497C23.637 13.7625 21.8565 14.5 20 14.5C18.1435 14.5 16.363 13.7625 15.0503 12.4497C13.7375 11.137 13 9.35652 13 7.5C13 5.64348 13.7375 3.86301 15.0503 2.55025C16.363 1.2375 18.1435 0.5 20 0.5Z"
              fill="white"
            />
          </svg>
        )}
        {icon && icon === 'company-phone' && (
          <svg xmlns="http://www.w3.org/2000/svg" width="42" height="41" viewBox="0 0 42 41" fill="none">
            <path
              d="M23.85 37.3983V23.3531H5.2799C4.71705 23.3528 4.15966 23.4635 3.63958 23.6787C3.1195 23.8939 2.64692 24.2095 2.24883 24.6074C1.85075 25.0053 1.53496 25.4777 1.31951 25.9977C1.10406 26.5177 0.993164 27.075 0.993164 27.6379V29.3907C0.993164 30.4805 1.3361 31.5436 1.96673 32.4314C4.90457 36.5543 9.71334 38.5948 16.2292 38.5948C19.106 38.5948 21.6533 38.1985 23.85 37.3983ZM16.2292 0.5C17.4802 0.5 18.7189 0.746399 19.8746 1.22513C21.0304 1.70386 22.0805 2.40555 22.9651 3.29012C23.8497 4.1747 24.5514 5.22485 25.0301 6.38061C25.5089 7.53636 25.7553 8.7751 25.7553 10.0261C25.7553 11.2771 25.5089 12.5158 25.0301 13.6715C24.5514 14.8273 23.8497 15.8775 22.9651 16.762C22.0805 17.6466 21.0304 18.3483 19.8746 18.827C18.7189 19.3058 17.4802 19.5522 16.2292 19.5522C13.7027 19.5522 11.2797 18.5485 9.49322 16.762C7.70673 14.9755 6.7031 12.5526 6.7031 10.0261C6.7031 7.49961 7.70673 5.07661 9.49322 3.29012C11.2797 1.50364 13.7027 0.5 16.2292 0.5ZM37.6724 15.7322C39.5128 15.7322 41.0065 17.2259 41.0065 19.0663V37.1659C41.0065 38.0501 40.6552 38.8982 40.03 39.5235C39.4047 40.1487 38.5566 40.5 37.6724 40.5H29.0894C28.2051 40.5 27.3571 40.1487 26.7318 39.5235C26.1065 38.8982 25.7553 38.0501 25.7553 37.1659V19.0663C25.7553 17.2259 27.2489 15.7322 29.0894 15.7322H37.6724ZM33.8581 32.8734H32.9055L32.7112 32.8868C32.3525 32.9361 32.026 33.1198 31.7975 33.4006C31.569 33.6814 31.4557 34.0385 31.4804 34.3997C31.5051 34.7609 31.6659 35.0993 31.9305 35.3464C32.195 35.5936 32.5435 35.7311 32.9055 35.7312H33.8581L34.0506 35.7179C34.4091 35.6686 34.7355 35.4851 34.9639 35.2044C35.1924 34.9238 35.3059 34.5669 35.2815 34.2059C35.257 33.8448 35.0965 33.5065 34.8324 33.2592C34.5682 33.0119 34.22 32.874 33.8581 32.8734Z"
              fill="white"
            />
          </svg>
        )}
        {icon && icon === 'compensation-plan' && (
          <svg xmlns="http://www.w3.org/2000/svg" width="38" height="41" viewBox="0 0 38 41" fill="none">
            <path
              d="M16.6469 0.5C14.1507 0.5 11.7568 1.49159 9.99174 3.25664C8.22669 5.02169 7.23509 7.41561 7.23509 9.91177C7.23509 12.4079 8.22669 14.8018 9.99174 16.5669C11.7568 18.3319 14.1507 19.3235 16.6469 19.3235C19.143 19.3235 21.5369 18.3319 23.302 16.5669C25.067 14.8018 26.0586 12.4079 26.0586 9.91177C26.0586 7.41561 25.067 5.02169 23.302 3.25664C21.5369 1.49159 19.143 0.5 16.6469 0.5ZM4.90333 21.6765C4.28365 21.674 3.66958 21.7939 3.09633 22.0292C2.52308 22.2646 2.00193 22.6108 1.56276 23.048C1.1236 23.4852 0.775057 24.0048 0.537131 24.577C0.299206 25.1491 0.176574 25.7627 0.17627 26.3824C0.17627 30.3612 2.13627 33.3612 5.1998 35.3165C7.66568 36.8882 10.8351 37.7824 14.2939 38.0529V28.7353C14.2939 27.4872 14.7897 26.2903 15.6722 25.4077C16.5548 24.5252 17.7517 24.0294 18.9998 24.0294H32.4869C32.0738 23.314 31.4798 22.72 30.7644 22.307C30.0491 21.8939 29.2376 21.6765 28.4116 21.6765H4.90333ZM37.8233 29.9118V36.9706C37.8233 37.9066 37.4515 38.8044 36.7896 39.4663C36.1277 40.1282 35.23 40.5 34.2939 40.5H20.1763C19.2402 40.5 18.3425 40.1282 17.6806 39.4663C17.0187 38.8044 16.6469 37.9066 16.6469 36.9706V29.9118C16.6469 28.9757 17.0187 28.078 17.6806 27.4161C18.3425 26.7542 19.2402 26.3824 20.1763 26.3824H34.2939C35.23 26.3824 36.1277 26.7542 36.7896 27.4161C37.4515 28.078 37.8233 28.9757 37.8233 29.9118ZM35.4704 36.9706V34.6176C34.5343 34.6176 33.6366 34.9895 32.9747 35.6514C32.3128 36.3133 31.941 37.211 31.941 38.1471H34.2939C34.2939 37.835 34.4179 37.5358 34.6385 37.3152C34.8591 37.0945 35.1584 36.9706 35.4704 36.9706ZM35.4704 29.9118C35.1584 29.9118 34.8591 29.7878 34.6385 29.5672C34.4179 29.3466 34.2939 29.0473 34.2939 28.7353H31.941C31.941 29.6714 32.3128 30.5691 32.9747 31.231C33.6366 31.8929 34.5343 32.2647 35.4704 32.2647V29.9118ZM20.1763 28.7353C20.1763 29.0473 20.0523 29.3466 19.8317 29.5672C19.6111 29.7878 19.3118 29.9118 18.9998 29.9118V32.2647C19.9359 32.2647 20.8336 31.8929 21.4955 31.231C22.1574 30.5691 22.5292 29.6714 22.5292 28.7353H20.1763ZM18.9998 36.9706C19.3118 36.9706 19.6111 37.0945 19.8317 37.3152C20.0523 37.5358 20.1763 37.835 20.1763 38.1471H22.5292C22.5292 37.211 22.1574 36.3133 21.4955 35.6514C20.8336 34.9895 19.9359 34.6176 18.9998 34.6176V36.9706ZM27.2351 29.9118C26.299 29.9118 25.4013 30.2836 24.7394 30.9455C24.0775 31.6074 23.7057 32.5051 23.7057 33.4412C23.7057 34.3772 24.0775 35.275 24.7394 35.9368C25.4013 36.5987 26.299 36.9706 27.2351 36.9706C28.1712 36.9706 29.0689 36.5987 29.7308 35.9368C30.3927 35.275 30.7645 34.3772 30.7645 33.4412C30.7645 32.5051 30.3927 31.6074 29.7308 30.9455C29.0689 30.2836 28.1712 29.9118 27.2351 29.9118Z"
              fill="white"
            />
          </svg>
        )}
        {icon && icon === 'team-name' && (
          <svg xmlns="http://www.w3.org/2000/svg" width="38" height="41" viewBox="0 0 38 41" fill="none">
            <path
              d="M16.6469 0.5C14.1507 0.5 11.7568 1.49159 9.99174 3.25664C8.22669 5.02169 7.23509 7.41561 7.23509 9.91177C7.23509 12.4079 8.22669 14.8018 9.99174 16.5669C11.7568 18.3319 14.1507 19.3235 16.6469 19.3235C19.143 19.3235 21.5369 18.3319 23.302 16.5669C25.067 14.8018 26.0586 12.4079 26.0586 9.91177C26.0586 7.41561 25.067 5.02169 23.302 3.25664C21.5369 1.49159 19.143 0.5 16.6469 0.5ZM4.90333 21.6765C4.28365 21.674 3.66958 21.7939 3.09633 22.0292C2.52308 22.2646 2.00193 22.6108 1.56276 23.048C1.1236 23.4852 0.775057 24.0048 0.537131 24.577C0.299206 25.1491 0.176574 25.7627 0.17627 26.3824C0.17627 30.3612 2.13627 33.3612 5.1998 35.3165C7.66568 36.8882 10.8351 37.7824 14.2939 38.0529V28.7353C14.2939 27.4872 14.7897 26.2903 15.6722 25.4077C16.5548 24.5252 17.7517 24.0294 18.9998 24.0294H32.4869C32.0738 23.314 31.4798 22.72 30.7644 22.307C30.0491 21.8939 29.2376 21.6765 28.4116 21.6765H4.90333ZM37.8233 29.9118V36.9706C37.8233 37.9066 37.4515 38.8044 36.7896 39.4663C36.1277 40.1282 35.23 40.5 34.2939 40.5H20.1763C19.2402 40.5 18.3425 40.1282 17.6806 39.4663C17.0187 38.8044 16.6469 37.9066 16.6469 36.9706V29.9118C16.6469 28.9757 17.0187 28.078 17.6806 27.4161C18.3425 26.7542 19.2402 26.3824 20.1763 26.3824H34.2939C35.23 26.3824 36.1277 26.7542 36.7896 27.4161C37.4515 28.078 37.8233 28.9757 37.8233 29.9118ZM35.4704 36.9706V34.6176C34.5343 34.6176 33.6366 34.9895 32.9747 35.6514C32.3128 36.3133 31.941 37.211 31.941 38.1471H34.2939C34.2939 37.835 34.4179 37.5358 34.6385 37.3152C34.8591 37.0945 35.1584 36.9706 35.4704 36.9706ZM35.4704 29.9118C35.1584 29.9118 34.8591 29.7878 34.6385 29.5672C34.4179 29.3466 34.2939 29.0473 34.2939 28.7353H31.941C31.941 29.6714 32.3128 30.5691 32.9747 31.231C33.6366 31.8929 34.5343 32.2647 35.4704 32.2647V29.9118ZM20.1763 28.7353C20.1763 29.0473 20.0523 29.3466 19.8317 29.5672C19.6111 29.7878 19.3118 29.9118 18.9998 29.9118V32.2647C19.9359 32.2647 20.8336 31.8929 21.4955 31.231C22.1574 30.5691 22.5292 29.6714 22.5292 28.7353H20.1763ZM18.9998 36.9706C19.3118 36.9706 19.6111 37.0945 19.8317 37.3152C20.0523 37.5358 20.1763 37.835 20.1763 38.1471H22.5292C22.5292 37.211 22.1574 36.3133 21.4955 35.6514C20.8336 34.9895 19.9359 34.6176 18.9998 34.6176V36.9706ZM27.2351 29.9118C26.299 29.9118 25.4013 30.2836 24.7394 30.9455C24.0775 31.6074 23.7057 32.5051 23.7057 33.4412C23.7057 34.3772 24.0775 35.275 24.7394 35.9368C25.4013 36.5987 26.299 36.9706 27.2351 36.9706C28.1712 36.9706 29.0689 36.5987 29.7308 35.9368C30.3927 35.275 30.7645 34.3772 30.7645 33.4412C30.7645 32.5051 30.3927 31.6074 29.7308 30.9455C29.0689 30.2836 28.1712 29.9118 27.2351 29.9118Z"
              fill="white"
            />
          </svg>
        )}
        {icon && icon === 'agent-type' && (
          <svg xmlns="http://www.w3.org/2000/svg" width="40" height="41" viewBox="0 0 40 41" fill="none">
            <path
              d="M16.4706 0.5C13.9744 0.5 11.5805 1.49159 9.81547 3.25664C8.05042 5.02169 7.05882 7.41561 7.05882 9.91177C7.05882 12.4079 8.05042 14.8018 9.81547 16.5669C11.5805 18.3319 13.9744 19.3235 16.4706 19.3235C18.9667 19.3235 21.3607 18.3319 23.1257 16.5669C24.8908 14.8018 25.8824 12.4079 25.8824 9.91177C25.8824 7.41561 24.8908 5.02169 23.1257 3.25664C21.3607 1.49159 18.9667 0.5 16.4706 0.5ZM4.72706 21.6765C4.10738 21.674 3.49331 21.7939 2.92006 22.0292C2.34681 22.2646 1.82566 22.6108 1.38649 23.048C0.947327 23.4852 0.598788 24.0048 0.360862 24.577C0.122936 25.1491 0.000304734 25.7627 0 26.3824C0 30.3612 1.96 33.3612 5.02353 35.3165C8.04 37.2388 12.1059 38.1471 16.4706 38.1471C17.4353 38.1471 18.3906 38.1024 19.3176 38.0129C17.4704 35.7174 16.4656 32.8582 16.4706 29.9118C16.4706 26.7824 17.5812 23.9118 19.4282 21.6765H4.72941H4.72706ZM27.9412 25.2059C27.9412 24.8159 28.0961 24.4418 28.3719 24.166C28.6477 23.8902 29.0217 23.7353 29.4118 23.7353C29.8018 23.7353 30.1758 23.8902 30.4516 24.166C30.7274 24.4418 30.8824 24.8159 30.8824 25.2059C30.8824 25.5959 30.7274 25.97 30.4516 26.2457C30.1758 26.5215 29.8018 26.6765 29.4118 26.6765C29.0217 26.6765 28.6477 26.5215 28.3719 26.2457C28.0961 25.97 27.9412 25.5959 27.9412 25.2059ZM30.5882 34.6176C30.5882 34.9297 30.4643 35.2289 30.2437 35.4495C30.023 35.6702 29.7238 35.7941 29.4118 35.7941C29.0997 35.7941 28.8005 35.6702 28.5799 35.4495C28.3592 35.2289 28.2353 34.9297 28.2353 34.6176V29.9118C28.2353 29.5997 28.3592 29.3005 28.5799 29.0799C28.8005 28.8592 29.0997 28.7353 29.4118 28.7353C29.7238 28.7353 30.023 28.8592 30.2437 29.0799C30.4643 29.3005 30.5882 29.5997 30.5882 29.9118V34.6176ZM18.8235 29.9118C18.8235 27.1036 19.9391 24.4104 21.9248 22.4248C23.9104 20.4391 26.6036 19.3235 29.4118 19.3235C32.2199 19.3235 34.9131 20.4391 36.8988 22.4248C38.8845 24.4104 40 27.1036 40 29.9118C40 32.7199 38.8845 35.4131 36.8988 37.3988C34.9131 39.3845 32.2199 40.5 29.4118 40.5C26.6036 40.5 23.9104 39.3845 21.9248 37.3988C19.9391 35.4131 18.8235 32.7199 18.8235 29.9118ZM21.1765 29.9118C21.1765 30.9932 21.3895 32.0641 21.8033 33.0633C22.2172 34.0624 22.8238 34.9703 23.5885 35.735C24.3533 36.4997 25.2611 37.1063 26.2603 37.5202C27.2594 37.934 28.3303 38.1471 29.4118 38.1471C30.4932 38.1471 31.5641 37.934 32.5633 37.5202C33.5624 37.1063 34.4703 36.4997 35.235 35.735C35.9997 34.9703 36.6063 34.0624 37.0202 33.0633C37.434 32.0641 37.6471 30.9932 37.6471 29.9118C37.6471 27.7276 36.7794 25.633 35.235 24.0885C33.6906 22.5441 31.5959 21.6765 29.4118 21.6765C27.2276 21.6765 25.133 22.5441 23.5885 24.0885C22.0441 25.633 21.1765 27.7276 21.1765 29.9118Z"
              fill="white"
            />
          </svg>
        )}
        <p>{title}</p>
      </AgentContactListHeader>

      {readOnly ? (
        <p>{value || ''}</p>
      ) : name === 'compensation_plan' ? (
        <SelectCompensation ref={ref} name={name} onChange={onChange} value={value}>
          <option value="Team Agent 80/20">Team Agent 80/20</option>
          <option value="90/10">90/10</option>
          <option value="Team Agent 90/10">Team Agent 90/10</option>
          <option value="70/30">70/30</option>
          <option value="Non team agent (no commission split)">Non team agent (no commission split)</option>
        </SelectCompensation>
      ) : (
        <AgentContactListField
          type={type || 'input'}
          className={hasError}
          ref={ref}
          name={name}
          onChange={onChange}
          value={value}
        />
      )}
    </AgentContactListItemWrapper>
  );
});

const AgentAdditionalDetailsContainer = styled.div`
  display: flex;
  max-width: 1000px;
  min-height: 850px;
  padding: 48px 0px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 80px;
  flex: 1 0 0;
  align-self: stretch;
  border-radius: 16px;
  background: var(--ywh-mystic, #edf2f4);
`;
const AgentAdditionalDetailsInput = styled.input`
  display: flex;
  padding: 16px 24px;
  align-items: center;
  align-self: stretch;
  border-radius: 8px;
  border: 1px solid var(--ywh-silver-chalice, #a8a8a8);

  /* ywh-h6-regular */
  font-family: Montserrat;
  font-size: 21px;
  font-style: normal;
  font-weight: 400;
  line-height: 31.5px; /* 150% */

  background: transparent;
  width: 100%;

  &.has-error {
    border: 1px solid red;
  }
`;
const AgentOfficeAddressWrapper = styled.div`
  display: flex;
  padding: 0px 64px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;
  align-self: stretch;

  & p {
    color: var(--ywh-black, #000);
    text-align: center;

    /* ywh-body-text */
    font-family: Montserrat;
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: 32.4px; /* 162% */
    border: none;
    word-break: break-word;
  }
`;
const AgentAdditionalDetailsHeader = styled.div`
  display: flex;
  max-width: 500px;
  margin: 0 auto;
  padding-bottom: 0px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  border-bottom: 1px solid var(--ywh-silver-chalice, #a8a8a8);

  & p {
    color: var(--ywh-black, #000);
    font-family: Montserrat;
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: 36px; /* 150% */
    margin-bottom: 8px;
    text-align: center;
  }
`;
const AgentOfficeAddress = ({ title, name, value, onChange, readOnly, hasError, refName }) => {
  return (
    <AgentOfficeAddressWrapper className="office_address-wrapper">
      <AgentAdditionalDetailsHeader>
        <svg xmlns="http://www.w3.org/2000/svg" width="36" height="41" viewBox="0 0 36 41" fill="none">
          <path
            d="M30.6314 29.5078C33.2525 30.6215 34.8419 32.0825 34.8419 33.6847C34.8419 37.1731 27.3009 40.0004 17.9998 40.0004C8.69877 40.0004 1.15771 37.1731 1.15771 33.6847C1.15771 32.0847 2.74719 30.6194 5.36824 29.5078"
            stroke="#5284E0"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M19.5549 33L19.5654 32.9895L19.5907 32.96L19.6854 32.8547L20.0349 32.4632C21.7842 30.4708 23.434 28.3932 24.9781 26.2379C26.3296 24.3432 27.7149 22.1958 28.7696 20.0632C29.8012 17.9789 30.6328 15.6863 30.6328 13.5663C30.6328 6.04421 25.1212 0 18.0012 0C10.8812 0 5.36963 6.04211 5.36963 13.5663C5.36963 15.6863 6.20121 17.9789 7.23279 20.0632C8.28752 22.1958 9.67489 24.3432 11.0223 26.2379C12.6695 28.5351 14.4369 30.7438 16.317 32.8547L16.4117 32.96L16.437 32.9895L16.4475 33C16.6448 33.2157 16.8848 33.388 17.1523 33.5059C17.4198 33.6238 17.7089 33.6846 18.0012 33.6846C18.2935 33.6846 18.5826 33.6238 18.8501 33.5059C19.1176 33.388 19.3576 33.2157 19.5549 33ZM18.0012 8.42105C16.8845 8.42105 15.8135 8.86466 15.0239 9.65429C14.2343 10.4439 13.7907 11.5149 13.7907 12.6316C13.7907 13.7483 14.2343 14.8192 15.0239 15.6089C15.8135 16.3985 16.8845 16.8421 18.0012 16.8421C19.1179 16.8421 20.1889 16.3985 20.9785 15.6089C21.7681 14.8192 22.2117 13.7483 22.2117 12.6316C22.2117 11.5149 21.7681 10.4439 20.9785 9.65429C20.1889 8.86466 19.1179 8.42105 18.0012 8.42105Z"
            fill="#5284E0"
          />
        </svg>
        <p>{title}</p>
      </AgentAdditionalDetailsHeader>
      {readOnly ? (
        <p>{value}</p>
      ) : (
        <AgentAdditionalDetailsInput
          name={name}
          value={value}
          onChange={onChange}
          ref={refName}
          className={hasError ? 'has-error' : ''}
        />
      )}
    </AgentOfficeAddressWrapper>
  );
};

const AgentCommunityViewMoreButton = styled.button`
  font-weight: 500;
  background-color: transparent;
  font-size: 17px;
  border-radius: 16px;
  width: 300px;
  height: 300px;
  color: #04246b;
  border: 1px solid #04246b;

  &:hover {
    background-color: transparent;
  }
`;

const AgentCompanyWebsiteWrapper = styled.div`
  display: flex;
  align-items: start;
  align-self: stretch;
  flex-wrap: ${(props) => (props.fullWidth ? 'wrap' : 'nowrap')};
  gap: ${(props) => (props.fullWidth ? '2rem' : '0px')};
`;
const AgentCompanyWebsiteItemWrapper = styled.div`
  display: flex;
  padding: 0px 32px;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  flex: ${(props) => (props.fullWidth ? '0 0 100%' : '1 0 0')};
  word-break: break-word;
  & p {
    color: var(--ywh-black, #000);
    text-align: center;

    /* ywh-body-text */
    font-family: Montserrat;
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: 32.4px; /* 162% */
    border: none;
  }
`;
const AgentCompanyWebsiteItem = ({ fullWidth, title, name, value, onChange, read, companyRef, hasError }) => {
  return (
    <AgentCompanyWebsiteItemWrapper fullWidth={fullWidth}>
      <AgentAdditionalDetailsHeader>
        <svg xmlns="http://www.w3.org/2000/svg" width="49" height="40" viewBox="0 0 49 40" fill="none">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M28.9444 8.88867C28.355 8.88867 27.7898 9.1228 27.373 9.53955C26.9563 9.95629 26.7222 10.5215 26.7222 11.1109V28.8887C26.7222 29.478 26.9563 30.0433 27.373 30.46C27.7898 30.8768 28.355 31.1109 28.9444 31.1109H37.8333C38.4226 31.1109 38.9879 30.8768 39.4046 30.46C39.8214 30.0433 40.0555 29.478 40.0555 28.8887V11.1109C40.0555 10.5215 39.8214 9.95629 39.4046 9.53955C38.9879 9.1228 38.4226 8.88867 37.8333 8.88867H28.9444ZM35.6111 13.3331H31.1666V26.6664H35.6111V13.3331Z"
            fill="#5284E0"
          />
          <path
            d="M11.1666 8.88867C10.5772 8.88867 10.012 9.1228 9.59521 9.53955C9.17846 9.95629 8.94434 10.5215 8.94434 11.1109C8.94434 11.7003 9.17846 12.2655 9.59521 12.6822C10.012 13.099 10.5772 13.3331 11.1666 13.3331H20.0554C20.6448 13.3331 21.21 13.099 21.6268 12.6822C22.0435 12.2655 22.2777 11.7003 22.2777 11.1109C22.2777 10.5215 22.0435 9.95629 21.6268 9.53955C21.21 9.1228 20.6448 8.88867 20.0554 8.88867H11.1666ZM11.1666 17.7776C10.5772 17.7776 10.012 18.0117 9.59521 18.4284C9.17846 18.8452 8.94434 19.4104 8.94434 19.9998C8.94434 20.5892 9.17846 21.1544 9.59521 21.5711C10.012 21.9879 10.5772 22.222 11.1666 22.222H20.0554C20.6448 22.222 21.21 21.9879 21.6268 21.5711C22.0435 21.1544 22.2777 20.5892 22.2777 19.9998C22.2777 19.4104 22.0435 18.8452 21.6268 18.4284C21.21 18.0117 20.6448 17.7776 20.0554 17.7776H11.1666ZM8.94434 28.8887C8.94434 28.2993 9.17846 27.7341 9.59521 27.3173C10.012 26.9006 10.5772 26.6664 11.1666 26.6664H20.0554C20.6448 26.6664 21.21 26.9006 21.6268 27.3173C22.0435 27.7341 22.2777 28.2993 22.2777 28.8887C22.2777 29.478 22.0435 30.0433 21.6268 30.46C21.21 30.8768 20.6448 31.1109 20.0554 31.1109H11.1666C10.5772 31.1109 10.012 30.8768 9.59521 30.46C9.17846 30.0433 8.94434 29.478 8.94434 28.8887Z"
            fill="#5284E0"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M6.72233 0C4.95422 0 3.25853 0.702379 2.00829 1.95262C0.758043 3.20286 0.0556641 4.89856 0.0556641 6.66667V33.3333C0.0556641 35.1014 0.758043 36.7971 2.00829 38.0474C3.25853 39.2976 4.95422 40 6.72233 40H42.2779C44.046 40 45.7417 39.2976 46.9919 38.0474C48.2422 36.7971 48.9446 35.1014 48.9446 33.3333V6.66667C48.9446 4.89856 48.2422 3.20286 46.9919 1.95262C45.7417 0.702379 44.046 0 42.2779 0H6.72233ZM42.2779 4.44444H6.72233C6.13296 4.44444 5.56773 4.67857 5.15098 5.09532C4.73423 5.51207 4.50011 6.0773 4.50011 6.66667V33.3333C4.50011 33.9227 4.73423 34.4879 5.15098 34.9047C5.56773 35.3214 6.13296 35.5556 6.72233 35.5556H42.2779C42.8673 35.5556 43.4325 35.3214 43.8492 34.9047C44.266 34.4879 44.5001 33.9227 44.5001 33.3333V6.66667C44.5001 6.0773 44.266 5.51207 43.8492 5.09532C43.4325 4.67857 42.8673 4.44444 42.2779 4.44444Z"
            fill="#5284E0"
          />
        </svg>
        <p>{title}</p>
      </AgentAdditionalDetailsHeader>
      {read ? (
        <p>
          {' '}
          {value && (
            <a href={value.includes('http') ? value : '//' + value} target="_blank">
              {value || ''}
            </a>
          )}
        </p>
      ) : (
        <AgentAdditionalDetailsInput
          name={name}
          value={value}
          onChange={onChange}
          ref={companyRef}
          className={hasError ? 'has-error' : ''}
        />
      )}
    </AgentCompanyWebsiteItemWrapper>
  );
};

const AgentCompanyWebsite = ({
  fullWidth = false,
  company,
  personal,
  onChange,
  read = false,
  company_website_name,
  personal_website_name,
  companyRef,
  hasError,
}) => {
  return (
    <AgentCompanyWebsiteWrapper fullWidth={fullWidth}>
      <AgentCompanyWebsiteItem
        fullWidth={fullWidth}
        read={read}
        title="Company Website"
        name={company_website_name ?? 'company_website'}
        companyRef={companyRef}
        hasError={hasError}
        onChange={onChange}
        value={company}
      />
      <AgentCompanyWebsiteItem
        fullWidth={fullWidth}
        read={read}
        title="Personal Website"
        name={personal_website_name ?? 'personal_website'}
        onChange={onChange}
        value={personal}
      />
    </AgentCompanyWebsiteWrapper>
  );
};

const AgentCityStateServedContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 64px;
  align-self: stretch;
  padding: 0 64px;
`;
const AgentCityStateServedContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 64px;
  align-self: stretch;

  & ul {
    display: flex;
    align-items: flex-start;
    align-content: flex-start;
    gap: 16px;
    align-self: stretch;
    flex-wrap: wrap;

    & li {
      flex: 0 0 calc(33.333% - 16px);
      color: var(--ywh-black, #000);
      list-style: disc;
      /* ywh-body-text */
      font-family: Montserrat;
      font-size: 20px;
      font-style: normal;
      font-weight: 400;
      line-height: 32.4px; /* 162% */
      padding: 16px 16px 16px 0px;
      position: relative;

      & .close-icon-wrapper {
        position: absolute;
        right: 10px;
        top: -20px;
      }
      & .edit-icon-wrapper {
        position: absolute;
        right: 44px;
        top: -20px;
      }
    }
  }
`;
const AgentCityStateServedHeader = styled.div`
  display: flex;
  padding-bottom: 0px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  & p {
    color: var(--ywh-black, #000);
    text-align: center;

    /* ywh-h6-bold */
    font-family: Montserrat;
    font-size: 21px;
    font-style: normal;
    font-weight: 700;
    line-height: 31.5px; /* 150% */
    border-bottom: 1px solid var(--ywh-silver-chalice, #a8a8a8);
    padding-bottom: 16px;
    width: 100%;
  }
`;
const AgentCityStateServedButton = styled.button`
  display: flex;
  padding: 16px 32px;
  justify-content: center;
  align-items: center;
  gap: 24px;
  border-radius: 8px;
  background: var(--ywh-royal-blue, #04246b);
  color: #fff;
  text-align: center;
  font-family: Montserrat;
  font-size: 19px;
  font-style: normal;
  font-weight: 700;
  line-height: 19px; /* 100% */
`;
const AgentCityStateServedResultContainer = styled.div`
  gap: 8px;
  display: flex;
  flex-direction: column;
  height: 500px;
  overflow: auto;
`;
const AgentCityStateServed = ({
  title,
  description,
  icon,
  name,
  values = [],
  readOnly,
  onChange,
  params,
  onChangeCommunities,
}) => {
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(true);
  const [show, setShow] = useState(false);
  const [selectedValues, setSelectedValues] = useState(values || []);
  const [keyword, setKeyword] = useState('');
  const fetchData = async () => {
    setLoading(true);
    if (title === 'state') {
      setLoading(false);
      setResults(
        US_STATES.map((s) => {
          return {
            ...s,
            value: s.abbreviation,
          };
        }),
      );
    }

    if (title === 'city') {
      if (params && params.length > 0) {
        // restructure for pagination
        const cities = await Promise.all(
          params
            .map((v) => v.value)
            .sort()
            .map((v) => getMarkets({ state: v })),
        ).then((all) => {
          return all
            .filter((a) => a.result)
            .map((a) => {
              return {
                state: a.state?.code,
                cities: a.cities?.map((aa, index) => {
                  return {
                    name: aa.city + ', ' + a.state.code,
                    value: aa.city,
                    communities: aa.communities,
                  };
                }),
              };
            });
        });
        setLoading(false);
        setResults(
          cities
            .map((c) => c.cities)
            .flat()
            .map((cc) => {
              return {
                name: cc.name,
                value: cc.value,
                communities: cc.communities,
              };
            }),
        );
      }
    }

    if (title === 'community') {
      if (params && params.length > 0) {
        // console.log('community params', params)
        setLoading(false);
        setResults(
          params
            .map((p) =>
              p.communities.map((pp) => {
                return {
                  ...pp,
                  extra_name: pp.name + ', ' + p.name,
                };
              }),
            )
            .flat()
            .map(({ extra_name, id }) => {
              return {
                name: extra_name,
                value: id,
              };
            }),
        );
      }
    }

    if (title == 'agents') {
      const result = await getAgents();
      if (result.result) {
        setResults(
          result.agents.map((a) => {
            return {
              ...a,
              name: `${a.first_name || ''} ${a.last_name || ''}`,
              value: a.id,
            };
          }),
        );
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    fetchData();
  }, [params]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    setSelectedValues(values);
  }, [values]);
  return (
    <>
      <AgentCityStateServedContent>
        <AgentCityStateServedHeader>
          <svg xmlns="http://www.w3.org/2000/svg" width="38" height="45" viewBox="0 0 38 45" fill="none">
            <path
              d="M18.9998 0C9.38634 0 0.688477 7.3703 0.688477 18.7691C0.688477 26.0478 6.29631 34.6083 17.4891 44.4507C18.3131 45.1831 19.7093 45.1831 20.5333 44.4507C31.7032 34.6083 37.3111 26.0478 37.3111 18.7691C37.3111 7.3703 28.6132 0 18.9998 0ZM9.13456 24.0107C11.8584 21.882 15.2688 20.6002 18.9998 20.6002C22.7307 20.6002 26.1412 21.882 28.865 24.0107C26.8965 27.4212 23.2343 29.7558 18.9998 29.7558C14.7653 29.7558 11.103 27.4212 9.13456 24.0107ZM18.9998 9.15565C21.5176 9.15565 23.5776 11.2157 23.5776 13.7335C23.5776 16.2513 21.5176 18.3113 18.9998 18.3113C16.482 18.3113 14.4219 16.2513 14.4219 13.7335C14.4219 11.2157 16.482 9.15565 18.9998 9.15565Z"
              fill="#5284E0"
            />
          </svg>
          <p>{description}</p>
        </AgentCityStateServedHeader>

        {readOnly && values && values.length > 0 ? (
          <ul>
            {title === 'community'
              ? values.map((c) => (
                  <li key={c.id}>
                    <a
                      href={`/${title}/${c.address.state.toLowerCase()}/${c.address.city.toLowerCase()}/${_.kebabCase(
                        c.name,
                      )}/${c.id}`}
                    >
                      {c.address ? c.name + ', ' + c.address.city + ', ' + c.address.state : c.name}
                    </a>
                  </li>
                ))
              : title === 'city'
              ? values.map((d) => {
                  return (
                    <li key={d.name + d.city}>
                      {d.state && d.city ? (
                        <a href={'/community/' + d.state + '/' + encodeURIComponent(d.city.toLowerCase())}>
                          {d.name.replace('|', ', ')}
                        </a>
                      ) : (
                        d.name
                      )}
                    </li>
                  );
                })
              : title === 'agents'
              ? JSON.parse(values).map((d) => {
                  return (
                    <li key={d.value}>
                      <a href={'/admin/agent/' + d.value}>{d.name}</a>
                    </li>
                  );
                })
              : values.split(',').map((d) => {
                  return (
                    <li key={d}>
                      <a href={'/community/' + d}>{getStateByCode(d.trim())}</a>
                    </li>
                  );
                })}
          </ul>
        ) : null}

        {!readOnly && values && values.length > 0 ? (
          <ul>
            {values.map((d) => {
              return (
                <li>
                  {selectedValues.find((s) => s.name === d.name) && getUserType() === '2' && (
                    <>
                      <EditIcon onClick={() => setShow(!show)} />
                      <CloseIcon
                        onClick={() => {
                          setSelectedValues(selectedValues.filter((v) => v.value !== d.value));
                          onChange(
                            name,
                            selectedValues.filter((v) => v.value !== d.value),
                          );
                        }}
                      />
                    </>
                  )}
                  {title == 'community' && d.address ? d.name + ' ' + d.address.city + ', ' + d.address.state : d.name}
                </li>
              );
            })}
          </ul>
        ) : null}
        {!readOnly && getUserType() === '2' && (
          <AgentCityStateServedButton
            onClick={(e) => {
              e.preventDefault();
              setShow(!show);
            }}
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="31" height="30" viewBox="0 0 31 30" fill="none">
              <path
                d="M17 13.5V7.5H14V13.5H8V16.5H14V22.5H17V16.5H23V13.5H17ZM15.5 30C11.5218 30 7.70644 28.4196 4.8934 25.6066C2.08035 22.7936 0.5 18.9782 0.5 15C0.5 11.0218 2.08035 7.20644 4.8934 4.3934C7.70644 1.58035 11.5218 0 15.5 0C19.4782 0 23.2936 1.58035 26.1066 4.3934C28.9196 7.20644 30.5 11.0218 30.5 15C30.5 18.9782 28.9196 22.7936 26.1066 25.6066C23.2936 28.4196 19.4782 30 15.5 30Z"
                fill="white"
              />
            </svg>
            ADD {title.toUpperCase()}{' '}
          </AgentCityStateServedButton>
        )}
      </AgentCityStateServedContent>
      {!readOnly && (
        <Modal
          show={show}
          size="lg"
          centered
          onHide={() => {
            onChange(name, selectedValues);
            setShow(!show);
          }}
          dialogClassName="modal-90w"
        >
          <Modal.Header closeButton>Select {title.toUpperCase()}</Modal.Header>
          <Modal.Body>
            {loading && <Loader />}
            {!loading && (
              <AgentCityStateServedResultContainer>
                {!loading && (
                  <Form.Control
                    placeholder={`Search ${title}`}
                    onChange={(e) => setKeyword(e.target.value.toLowerCase())}
                  />
                )}
                {!results.length ? (
                  <p style={{ justifyContent: 'center', flex: 1, display: 'flex', alignItems: 'center' }}>
                    NO {title.toUpperCase()} YET
                  </p>
                ) : (
                  results
                    .filter(({ name }) => {
                      return name.toLowerCase().includes(keyword);
                    })
                    .map(({ name, value, communities }) => (
                      <Form.Check
                        checked={(selectedValues && selectedValues.find((s) => s.name == name || s.value == value)) || false}
                        style={{ minHeight: 'auto' }}
                        onChange={(e) => {
                          const { checked, name, value } = e.target;
                          if (checked) {
                            if(selectedValues && _.isArray(selectedValues) ) {
                              setSelectedValues([...selectedValues, { name, value, communities }]);
                            } else {
                              setSelectedValues([{ name, value, communities }]);
                            }
                          } else {
                            setSelectedValues(selectedValues.filter((v) => v.value != value));
                          }
                          return;
                        }}
                        label={name}
                        name={name}
                        value={value}
                      />
                    ))
                )}
              </AgentCityStateServedResultContainer>
            )}
          </Modal.Body>
          {!loading && (
            <Modal.Footer>
              <Button
                variant="primary"
                onClick={(e) => {
                  e.preventDefault();
                  onChange(name, selectedValues);
                  setShow(!show);
                }}
              >
                {' '}
                Save{' '}
              </Button>
            </Modal.Footer>
          )}
        </Modal>
      )}
    </>
  );
};

const AgentDetailsBioWrapper = styled.div`
  display: flex;
  min-height: 500px;
  padding-top: 48px;
  flex-direction: column;
  justify-content: center;
  align-items: start;
  gap: 48px;
  align-self: stretch;

  &.has-error textarea {
    border: 1px solid red;
  }
`;
const AgentDetailsBioHeader = styled.div`
  display: flex;
  padding-bottom: 24px;
  align-items: center;
  gap: 24px;
  align-self: stretch;
  border-bottom: 1px solid var(--ywh-silver-chalice, #a8a8a8);

  & p {
    color: var(--ywh-royal-blue, #04246b);

    /* ywh-h2-montserrat */
    font-family: Montserrat;
    font-size: 39px;
    font-style: normal;
    font-weight: 700;
    line-height: 50.7px; /* 130% */
  }

  & span {
    color: var(--ywh-silver-chalice, #a8a8a8);

    /* ywh-h5 */
    font-family: Montserrat;
    font-size: 24px;
    font-style: normal;
    font-weight: 500;
    line-height: 36px; /* 150% */
  }
`;
const AgentDetailsBioText = styled.textarea`
  display: flex;
  padding: 32px;
  flex-direction: column;
  align-items: flex-start;
  flex: 1 0 0;
  align-self: stretch;
  border-radius: 16px;
  border: 1px solid var(--ywh-silver-chalice, #a8a8a8);
`;
const AgentDetailsBioGalleryWrapper = styled.div`
  display: flex;
  padding: 90.519px 73px 90.481px 73px;
  justify-content: center;
  align-items: center;
  border-radius: 16px;
  background: var(--ywh-mercury, #e8e8e8);

  & p {
    color: var(--ywh-silver-chalice, #a8a8a8);
    text-align: center;

    /* ywh-h5-regular */
    font-family: Montserrat;
    font-size: 24px;
    font-style: normal;
    font-weight: 400;
    line-height: 36px; /* 150% */
  }

  &.has-image {
    padding: 0px;
    max-width: 300px;
    min-height: 300px;
    overflow: hidden;
    & img {
      object-fit: cover;
      width: 300px;
      height: 300px;
    }
  }
`;
const AgentDetailsBioGalleryIcon = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;
  cursor: pointer;
`;
const AgentDetailsBioHeaderHeader = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
`;

const AgentDetailsBioGalleryContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  row-gap: 32px;
  column-gap: 16px;
`;

const ImagePreview = ({ file }) => {
  const [image, setImage] = useState('');
  // console.log('file', file)
  if (file && file.id && file.url) {
    if (file.url.includes('http')) return <img src={file.url} />;
    else return <img src={`${COMMUNITY_IMAGE_URL}` + file.url} />;
  } else if (typeof file === 'string') {
    setImage(file);
  } else {
    let reader = new FileReader();
    reader.onloadend = () => {
      setImage(reader.result);
    };
    reader.readAsDataURL(file);
  }
  return <img src={image} />;
};
const AgentDetailsBioGallery = ({ community, onChangeFiles, photos, readOnly, path }) => {
  const navigate = useNavigate();
  const filesRef = useRef(null);
  const { name, value, address, id } = community;
  const [tempPhotos, setTempPhotos] = useState(photos || []);
  const handleFileChange = (e) => {
    setTempPhotos(Array.from(e.target.files).concat(tempPhotos));
    onChangeFiles(name, value, e.target.files);
  };

  useEffect(() => {
    setTempPhotos(_.reverse(photos));
  }, [photos]);

  return (
    <>
      <h3>
        {address?.state ? `${address.state}, ` : ''}
        {address?.city ? `${address.city}, ` : ''}
        {name?.name ?? name ?? ''}
      </h3>
      <AgentDetailsBioGalleryContainer>
        {!readOnly && (
          <AgentDetailsBioGalleryWrapper onClick={() => filesRef.current.click()}>
            <AgentDetailsBioGalleryIcon>
              <svg xmlns="http://www.w3.org/2000/svg" width="76" height="76" viewBox="0 0 76 76" fill="none">
                <path
                  d="M75.5 38.0195C75.5 37.025 75.1049 36.0711 74.4017 35.3679C73.6984 34.6646 72.7446 34.2695 71.75 34.2695C70.7554 34.2695 69.8016 34.6646 69.0983 35.3679C68.3951 36.0711 68 37.025 68 38.0195H75.5ZM38 8.01953C38.9946 8.01953 39.9484 7.62444 40.6516 6.92118C41.3549 6.21792 41.75 5.26409 41.75 4.26953C41.75 3.27497 41.3549 2.32114 40.6516 1.61788C39.9484 0.914619 38.9946 0.519531 38 0.519531V8.01953ZM66.125 68.0195H9.875V75.5195H66.125V68.0195ZM8 66.1445V9.89453H0.5V66.1445H8ZM68 38.0195V66.1445H75.5V38.0195H68ZM9.875 8.01953H38V0.519531H9.875V8.01953ZM9.875 68.0195C9.37772 68.0195 8.90081 67.822 8.54918 67.4704C8.19754 67.1187 8 66.6418 8 66.1445H0.5C0.5 68.6309 1.48772 71.0155 3.24587 72.7737C5.00403 74.5318 7.3886 75.5195 9.875 75.5195V68.0195ZM66.125 75.5195C68.6114 75.5195 70.996 74.5318 72.7541 72.7737C74.5123 71.0155 75.5 68.6309 75.5 66.1445H68C68 66.6418 67.8025 67.1187 67.4508 67.4704C67.0992 67.822 66.6223 68.0195 66.125 68.0195V75.5195ZM8 9.89453C8 9.39725 8.19754 8.92034 8.54918 8.56871C8.90081 8.21708 9.37772 8.01953 9.875 8.01953V0.519531C7.3886 0.519531 5.00403 1.50725 3.24587 3.26541C1.48772 5.02356 0.5 7.40813 0.5 9.89453H8Z"
                  fill="#A8A8A8"
                />
                <path
                  d="M4.25 58.6445L24.2994 40.2658C24.9752 39.6464 25.8544 39.296 26.7709 39.2808C27.6874 39.2656 28.5778 39.5867 29.2738 40.1833L53 60.5195M45.5 51.1445L54.4494 42.1952C55.0877 41.5564 55.9351 41.1695 56.8358 41.1054C57.7366 41.0413 58.6302 41.3044 59.3525 41.8464L71.75 51.1445M49.25 15.5195H71.75M60.5 4.26953V26.7695"
                  stroke="#A8A8A8"
                  strokeWidth="4"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <p>ADD PHOTO</p>
            </AgentDetailsBioGalleryIcon>

            <input ref={filesRef} type="file" onChange={handleFileChange} name="photos" multiple hidden />
          </AgentDetailsBioGalleryWrapper>
        )}

        {tempPhotos
          .filter((_, index) => index < 7)
          .map((tp) => (
            <AgentDetailsBioGalleryWrapper className="has-image" key={tp.id}>
              <ImagePreview file={tp} />
            </AgentDetailsBioGalleryWrapper>
          ))}
        {/* <AgentCommunityViewMoreButtonContainer> */}
        {readOnly && (
          <AgentCommunityViewMoreButton
            onClick={() =>
              navigate(
                `/community/${address?.state.toLowerCase()}/${address?.city.toLowerCase()}/${_.kebabCase(
                  name?.name ?? name ?? '',
                )}/${id}`,
              )
            }
          >
            Learn More about this community
          </AgentCommunityViewMoreButton>
        )}
        {/* </AgentCommunityViewMoreButtonContainer> */}
      </AgentDetailsBioGalleryContainer>
    </>
  );
};

const AgentDetailsBio = forwardRef(
  (
    {
      title,
      icon,
      subtitle,
      type,
      name,
      values,
      readOnly = false,
      onChange,
      communities,
      photos = [],
      onChangeFiles,
      hasError,
      placeholder = "Agent's bio"
    },
    ref,
  ) => {
    return (
      <AgentDetailsBioWrapper className={hasError} ref={ref}>
        <AgentDetailsBioHeader>
          {icon && icon === 'bio-name' && (
            <svg xmlns="http://www.w3.org/2000/svg" width="100" height="117" viewBox="0 0 100 117" fill="none">
              <path
                d="M50 116.667L33.3333 100H11.1111C8.05556 100 5.4389 98.9111 3.26112 96.7333C1.08334 94.5555 -0.00369427 91.9407 9.43218e-06 88.8889V11.1111C9.43218e-06 8.05556 1.0889 5.4389 3.26668 3.26112C5.44445 1.08334 8.05927 -0.00369427 11.1111 9.43218e-06H88.8889C91.9444 9.43218e-06 94.5611 1.0889 96.7389 3.26668C98.9167 5.44445 100.004 8.05927 100 11.1111V88.8889C100 91.9444 98.9111 94.5611 96.7333 96.7389C94.5555 98.9167 91.9407 100.004 88.8889 100H66.6667L50 116.667ZM50 55.5556C55.3704 55.5556 59.9537 53.6574 63.75 49.8611C67.5463 46.0648 69.4444 41.4815 69.4444 36.1111C69.4444 30.7407 67.5463 26.1574 63.75 22.3611C59.9537 18.5648 55.3704 16.6667 50 16.6667C44.6296 16.6667 40.0463 18.5648 36.25 22.3611C32.4537 26.1574 30.5556 30.7407 30.5556 36.1111C30.5556 41.4815 32.4537 46.0648 36.25 49.8611C40.0463 53.6574 44.6296 55.5556 50 55.5556ZM50 101.111L62.2222 88.8889H88.8889V82.5C83.8889 77.5926 78.0778 73.7278 71.4556 70.9055C64.8333 68.0833 57.6815 66.6704 50 66.6667C42.3148 66.6667 35.1611 68.0796 28.5389 70.9055C21.9167 73.7315 16.1074 77.5963 11.1111 82.5V88.8889H37.7778L50 101.111Z"
                fill="#04246B"
              />
            </svg>
          )}
          {icon && icon === 'bio-community' && (
            <svg xmlns="http://www.w3.org/2000/svg" width="130" height="130" viewBox="0 0 130 130" fill="none">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M113.75 102.917C113.75 103.892 113.62 104.829 113.382 105.722L24.2775 16.6183C25.1928 16.374 26.136 16.2502 27.0833 16.25H102.917C105.79 16.25 108.545 17.3914 110.577 19.423C112.609 21.4547 113.75 24.2102 113.75 27.0833V102.917ZM16.25 27.0833C16.25 26.1083 16.38 25.1712 16.6183 24.2775L49.2158 56.875L16.25 89.8408V27.0833ZM56.875 64.5342L105.722 113.382C104.807 113.626 103.864 113.75 102.917 113.75H27.0833C24.5654 113.75 22.1261 112.873 20.1846 111.27C18.2432 109.666 16.9209 107.437 16.445 104.964L56.875 64.5342Z"
                fill="#04246B"
              />
            </svg>
          )}
          <AgentDetailsBioHeaderHeader>
            <span>{subtitle}</span>
            <p>{title}</p>
          </AgentDetailsBioHeaderHeader>
        </AgentDetailsBioHeader>
        {readOnly && type && type === 'text' && <p>{values}</p>}
        {readOnly &&
          type &&
          type === 'gallery' &&
          communities.map(
            (community) =>
              !!community.images.length && (
                <AgentDetailsBioGallery
                  readOnly
                  path={`${community.slug}/${community.area_id}`}
                  key={community.id}
                  community={{ ...community, value: community.id }}
                  photos={_.reverse(community.images)}
                  onChangeFiles={(name, value, files) => {
                    onChangeFiles(name, value, files);
                  }}
                />
              ),
          )}
        {!readOnly && type && type === 'text' && (
          <AgentDetailsBioText
            className={hasError}
            name={name}
            value={values}
            onChange={onChange}
            placeholder={placeholder}
          />
        )}
        {!readOnly &&
          type &&
          type === 'gallery' &&
          communities.map((community) => (
            <AgentDetailsBioGallery
              key={community.value}
              community={community}
              photos={_.reverse(community.images) || _.reverse(photos)}
              onChangeFiles={(name, value, files) => {
                onChangeFiles(name, value, files);
              }}
            />
          ))}
      </AgentDetailsBioWrapper>
    );
  },
);

const AgentFooterWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 48px;
  align-self: stretch;
  & p {
    color: #000;
    text-align: center;

    /* ywh-body-text */
    font-family: Montserrat;
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: 32.4px; /* 162% */
  }
`;
const AgentFooterButton = styled.button`
  display: flex;
  padding: 16px 64px;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  background: var(--ywh-royal-blue, #04246b);
  color: #fff;
  text-align: center;

  /* ywh-h5-bold */
  font-family: Montserrat;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 36px; /* 150% */

  &:disabled {
    background: #ccc;
    cursor: not-allowed;
  }
`;
const AgentFooter = ({ isSubmitting }) => {
  return (
    <AgentFooterWrapper>
      <p>By signing up, you agree to The New Home Collection's Terms and Conditions & Privacy Policy.</p>
      {/* <AgentFooterButton type="submit" disabled={isSubmitting}>
        SUBMIT
      </AgentFooterButton> */}
    </AgentFooterWrapper>
  );
};

const InputFile = styled.input`
  display: none;
`;
const AgentH1 = styled.h1`
  color: var(--ywh-royal-blue, #04246b);
  /* ywh-h1 */
  font-family: Playfair Display;
  font-size: 59px;
  font-style: normal;
  font-weight: 700;
  line-height: 76.7px; /* 130% */
`;
const IconWrapper = styled.div`
  cursor: pointer;
  & svg {
    cursor: pointer;
  }

  &.close-icon-wrapper {
    z-index: 5 !important;
  }
`;
const EditIcon = ({ onClick }) => {
  return (
    <IconWrapper className="edit-icon-wrapper">
      <svg onClick={onClick} xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
        <circle cx="15" cy="15" r="15" fill="white" />
        <path
          d="M15 0C6.705 0 0 6.705 0 15C0 23.295 6.705 30 15 30C23.295 30 30 23.295 30 15C30 6.705 23.295 0 15 0ZM19.65 7.605C19.86 7.605 20.07 7.68 20.25 7.845L22.155 9.75C22.5 10.08 22.5 10.605 22.155 10.92L20.655 12.42L17.58 9.345L19.08 7.845C19.23 7.68 19.44 7.605 19.65 7.605ZM16.695 10.215L19.785 13.305L10.695 22.395H7.605V19.305L16.695 10.215Z"
          fill="#04246B"
        />
      </svg>
    </IconWrapper>
  );
};

const CloseIcon = ({ onClick }) => {
  return (
    <IconWrapper className="close-icon-wrapper">
      <svg onClick={onClick} xmlns="http://www.w3.org/2000/svg" width="30" height="31" viewBox="0 0 30 31" fill="none">
        <path
          d="M15 0.5C6.71437 0.5 0 7.21625 0 15.5C0 23.7838 6.71437 30.5 15 30.5C23.2856 30.5 30 23.7838 30 15.5C30 7.21625 23.2856 0.5 15 0.5ZM21.9506 19.7994C22.3022 20.151 22.4997 20.6278 22.4997 21.125C22.4997 21.6222 22.3022 22.099 21.9506 22.4506C21.599 22.8022 21.1222 22.9997 20.625 22.9997C20.1278 22.9997 19.651 22.8022 19.2994 22.4506L15 18.1512L10.7006 22.4506C10.5269 22.6253 10.3203 22.764 10.0928 22.8586C9.86535 22.9532 9.62139 23.0019 9.375 23.0019C9.12861 23.0019 8.88465 22.9532 8.65715 22.8586C8.42965 22.764 8.2231 22.6253 8.04938 22.4506C7.8751 22.2766 7.73684 22.07 7.64251 21.8426C7.54818 21.6151 7.49962 21.3713 7.49962 21.125C7.49962 20.8787 7.54818 20.6349 7.64251 20.4074C7.73684 20.18 7.8751 19.9734 8.04938 19.7994L12.3488 15.5L8.04938 11.2006C7.6978 10.849 7.50028 10.3722 7.50028 9.875C7.50028 9.37779 7.6978 8.90095 8.04938 8.54938C8.40095 8.1978 8.87779 8.00028 9.375 8.00028C9.87221 8.00028 10.349 8.1978 10.7006 8.54938L15 12.8488L19.2994 8.54938C19.651 8.1978 20.1278 8.00028 20.625 8.00028C21.1222 8.00028 21.599 8.1978 21.9506 8.54938C22.3022 8.90095 22.4997 9.37779 22.4997 9.875C22.4997 10.3722 22.3022 10.849 21.9506 11.2006L17.6512 15.5L21.9506 19.7994Z"
          fill="#04246B"
        />
      </svg>
    </IconWrapper>
  );
};

const AddIcon = ({ onClick }) => {
  return (
    <IconWrapper>
      <svg onClick={onClick} xmlns="http://www.w3.org/2000/svg" width="30" height="31" viewBox="0 0 30 31" fill="none">
        <path
          d="M16.5 14V8H13.5V14H7.5V17H13.5V23H16.5V17H22.5V14H16.5ZM15 30.5C11.0218 30.5 7.20644 28.9196 4.3934 26.1066C1.58035 23.2936 0 19.4782 0 15.5C0 11.5218 1.58035 7.70644 4.3934 4.8934C7.20644 2.08035 11.0218 0.5 15 0.5C18.9782 0.5 22.7936 2.08035 25.6066 4.8934C28.4196 7.70644 30 11.5218 30 15.5C30 19.4782 28.4196 23.2936 25.6066 26.1066C22.7936 28.9196 18.9782 30.5 15 30.5Z"
          fill="#04246B"
        />
      </svg>
    </IconWrapper>
  );
};

const EditContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;
export {
  AgentAdditionalDetailsContainer,
  AgentAdditionalDetailsHeader,
  AgentAdditionalDetailsInput,
  AgentCityStateServed,
  AgentCityStateServedButton,
  AgentCityStateServedContainer,
  AgentCityStateServedContent,
  AgentCityStateServedHeader,
  AgentCompanyWebsite,
  AgentCompanyWebsiteItem,
  AgentCompanyWebsiteItemWrapper,
  AgentCompanyWebsiteWrapper,
  AgentContactContainer,
  AgentContactListField,
  AgentContactListHeader,
  AgentContactListItem,
  AgentContactListItemWrapper,
  AgentContactWrapper,
  AgentDetail,
  AgentDetailExtra,
  AgentDetailsBio,
  AgentDetailsBioGallery,
  AgentDetailsBioGalleryIcon,
  AgentDetailsBioGalleryWrapper,
  AgentDetailsBioHeader,
  AgentDetailsBioHeaderHeader,
  AgentDetailsBioText,
  AgentDetailsBioWrapper,
  AgentDetailsInput,
  AgentDetailsInputGroup,
  AgentDetailsWrapper,
  AgentEmailPasswordWrapper,
  AgentFooter,
  AgentFooterButton,
  AgentFooterWrapper,
  AgentH1,
  AgentInfoWrapper,
  AgentNameWrapper,
  AgentOfficeAddress,
  AgentOfficeAddressWrapper,
  AgentPage,
  CloseIcon,
  EditContainer,
  EditIcon,
  IconWrapper,
  Input,
  InputFile,
  InputGroup,
  UploadPhotoIcon,
  UploadPhotoWrapper,
};
